import { defineComponent as u, computed as t, openBlock as f, createElementBlock as s, normalizeClass as c, withModifiers as g, renderSlot as y } from "vue";
import { useSpacingClass as b } from "../../../composables/useSpacingClass.js";
import { isExternalUrl as k } from "../../../utils/isExternalUrl.js";
import { _ as S } from "../../../_plugin-vue_export-helper-dad06003.js";
const m = u({
  name: "VLink",
  props: {
    type: {
      type: String,
      default: "link",
      validator(e) {
        return ["button", "link", "separate"].indexOf(e) !== -1;
      }
    },
    order: {
      type: String,
      default: "tertiary",
      validator(e) {
        return [
          "primary",
          "secondary",
          "tertiary",
          "tertiary-grey",
          "quaternary"
        ].indexOf(e) !== -1;
      }
    },
    buttonSize: {
      type: String,
      default: "",
      validator(e) {
        return ["", "small", "widget-small", "big"].indexOf(e) !== -1;
      }
    },
    target: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: "",
      required: !0
    },
    fontSize: {
      type: String,
      default: "m",
      validator: (e) => ["xs", "s", "m"].includes(e)
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", ""].includes(e)
    },
    center: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "",
      validator: (e) => [
        "grey-400",
        "grey-500",
        "grey-600",
        "grey-900",
        "white",
        ""
      ].includes(e)
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  setup(e) {
    const { bottomSpacingClass: r, topSpacingClass: i } = b(e), a = t(
      () => e.bottomSpacing !== "" || e.topSpacing !== "" && e.type === "link"
    ), l = t(() => [
      `hobi-link--${e.type}`,
      e.fontSize !== "" ? `hobi-link--${e.fontSize}` : "",
      e.order,
      e.center ? "hobi-link--centered" : "",
      e.bottomSpacing !== "" ? r.value : "",
      e.buttonSize !== "" && e.type === "button" ? `hobi-button-size--${e.buttonSize}` : "",
      e.topSpacing !== "" ? i.value : "",
      a.value ? "hobi-link--block" : "",
      e.color !== "" ? "hobi-text--color-" + e.color : ""
    ]), o = t(() => e.target === "_blank" ? "() => trueener noreferrer" : ""), n = t(() => e.href ? k(e.href) : !1), d = t(() => e.target ? e.target : n.value ? "_blank" : "_self");
    return {
      linkClasses: l,
      rel: o,
      isExternal: n,
      generatedLinkTarget: d,
      handleClick: () => {
        if (!e.router)
          throw new Error("Router is not defined");
        return e.router.handleLink(e.href, {
          target: d.value
        });
      }
    };
  }
});
const h = ["target", "rel", "href", "disabled"];
function v(e, r, i, a, l, o) {
  return f(), s("a", {
    class: c(["hobi-link", e.linkClasses]),
    target: e.generatedLinkTarget,
    rel: e.rel,
    href: e.href,
    disabled: e.disabled ? !0 : null,
    onClick: r[0] || (r[0] = g((...n) => e.handleClick && e.handleClick(...n), ["prevent"]))
  }, [
    y(e.$slots, "default", {}, void 0, !0)
  ], 10, h);
}
const p = /* @__PURE__ */ S(m, [["render", v], ["__scopeId", "data-v-eeb3d4f0"]]);
export {
  p as default
};
